import React from "react"
import { graphql, Link } from "gatsby"
import { Layout } from "@bw/layouts"
import { Seo, Section, CmsImage } from "@bw/bits"
import { PageHeader } from "@bw/modules"
import { Breadcrumbs } from "@bw/partials"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { breakpoints } from "../theme"
import dateFormat from "../utils/dateFormat"
import parse from "html-react-parser"
//import { Form } from "@bw/modules"
import { Footer } from "../components/modules/mapModules.jsx"

const Flex = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  font-weight: 400;
  font-size: 17px;
  line-height: 152.9%;
  color: var(--font-color);
  font-family: "Ginto", georgia, serif;
  a {
    color: var(--font-color);
  }
  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 1fr;
  }
`

const Description = styled.p`
  font-size: 16px;
  line-height: 176.3%;
  margin: 40px 0;
`

const JobTemplate = ({ data, pageContext, location }) => {
  const { collectionJobs, mount /*, form */ } = data
  const job = collectionJobs
  const { t } = useTranslation()

  const breadcrumbsLinks = [
    {
      title: "Accueil",
      to: "/",
    },
    {
      title: "Offres d’emploi",
      to: "/emploi/",
    },
    {
      title: job.title,
      to: `/${job.slug}`,
    },
  ]

  //const formHandle = form.jobApplicationForm[0] || null

  const mountImage = mount.header[0]?.image

  return (
    <Layout {...{ pageContext }} color={job.color?.value}>
      <Seo
        url={location.href}
        title={job.metaTitle || job.title}
        description={job.metaDescription}
        image={job.image?.url}
        meta={[
          {
            name: "robots",
            content: job.doNotIndex
              ? "noindex, nofollow"
              : "max-image-preview:large, index, follow",
          },
        ]}
      />
      <PageHeader
        title={job.title}
        subtitle="Rejoignez le personnel de pharmacieplus."
        image={
          mountImage ? (
            <CmsImage src={mountImage} alt={mountImage.alt} />
          ) : undefined
        }
        pictogram={
          <svg className="icon">
            <use xlinkHref="/sprite-v2.svg#cross" />
          </svg>
        }
      />
      {breadcrumbsLinks && <Breadcrumbs breadcrumbs={breadcrumbsLinks} />}
      <Section margin="20px 0" containerSize="small">
        <Flex>
          <div>
            <div style={{ margin: "0 0 20px 0" }}>
              {t("job.occupancyRate")}: &nbsp;{job.occupancyRate}
            </div>
            <div style={{ margin: "0 0 20px 0" }}>
              {t("job.typeOfDuration")}: &nbsp;
              {job.typeOfDuration?.value === "fixed"
                ? job.duration
                : t("job.indeterminate")}
            </div>
          </div>
          <div>
            {job.pharmacy ? (
              <div style={{ margin: "0 0 20px 0" }}>
                {t("job.pharmacy")}: &nbsp;
                <Link to={job.pharmacy.slug}>{job.pharmacy.title}</Link>
              </div>
            ) : job.isRelatedToAdministration ? (
              <div>{t("job.pharmacy")}: &nbsp; Bremblens</div>
            ) : null}
            <div style={{ margin: "0 0 20px 0" }}>
              {t("job.startDate")}: &nbsp;
              {job.startDate
                ? dateFormat(job.startDate)
                : t("job.startDateTBD")}
            </div>
          </div>
        </Flex>
        <Description>
          {job.description ? parse(job.description) : undefined}
        </Description>
      </Section>
      {/*
      <Section title={t("job.formTitle")} containerSize="small">
        {formHandle && (
          <Form
            handle={formHandle}
            initialValues={{
              titre_de_l_offre_d_emploi: `${job.title} ${job.occupancyRate} - ${
                job.pharmacy?.title
                  ? "Pharmacie " + job.pharmacy.title
                  : "Centre Admin"
              }`,
            }}
          />
        )}
      </Section>
      */}
      <Footer modules={job.footer} />
    </Layout>
  )
}

export default JobTemplate

export const jobQuery = graphql`
  query jobQuery($id: String!) {
    collectionJobs(id: { eq: $id }) {
      title
      metaTitle
      metaDescription
      image {
        url
      }
      doNotIndex
      occupancyRate
      isRelatedToAdministration
      typeOfDuration {
        value
      }
      duration
      startDate
      description
      color {
        value
      }
      slug
      pharmacy {
        title
        slug
      }
      footer {
        __typename
        suptitle
        title
        subtitle
        buttonType {
          value
        }
        buttonUrl
        buttonIsExternal
        buttonText
        buttonPosition {
          value
        }
        buttonEntry {
          url
        }
      }
    }
    mount: collectionPages(mount: { handle: { eq: "jobs" } }) {
      slug
      header {
        ... on PageHeaderModule {
          image {
            url
          }
        }
      }
    }
    form: globals(handle: { eq: "jobApplicationForm" }) {
      jobApplicationForm
    }
  }
`
